import React, { useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import Header from "../Header";
import { Divider } from "antd";
import GaugeComponent from "react-gauge-component";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Bar, Doughnut } from "react-chartjs-2";
import { useSelector } from "react-redux";
import usePDFExport from "../../../hooks/usePDFExport";
import {
  assetHealthArc,
  assetHealthPointer,
  assetHealthStyle,
  assetHealthStatusData,
  preventiveMaintenanceDataStatusData,
  tpvstatusData,
  incidentBarStatusData,
  IncidentDoughnutStatusData,
  workRequestStatusData,
  incidentMetaDataSecond,
  barOptions,
  doughnutOptions,
  doughnutChartCenterValue,
  commonPlugins,
  renderStatusData,
  renderItemsWithLabelClass,
  doughnutcommonPlugins,
} from "./constant/maintenanceConstantData";
import {
  monthNames,
  getQuarterRange,
  getQuarterMonths,
  getMonthData,
} from "./actions/maintenanceDashboardService";
import {
  AssetHealthComponent,
  IncidentChildComponent,
  PreventiveMaintenanceChildComponent,
  TpvChildComponent,
  WorkRequestChildComponent,
} from "./maintenanceCommonComponent";

export default function MaintenanceDashboardReport() {
  const location = useLocation();
  const [redirect, setRedirect] = useState(false);
  const {
    tpvData,
    preventiveMaintenanceData,
    incidentBarData,
    incidenDoughnutData,
    workRequestData,
    WorkRequestChartData,
    IncidentTotalCount: incidentTotalCount,
    tpvScore,
    incidentScore,
    preventiveMaintenceScore,
    maintenanceWorkRequestScore,
    // weights: assetHealthWeights,
    PmpEndDate: endDate,
    PmpStartDate: startDate,
    PmpChartData: pmpChartData,
    TpvTotalCount: tpvTotalCount,
    pmpYtdTotal,
    requestYdtTotal,
    StoreList: storeList,
    assetScore,
  } = useSelector((state) => state?.maintenanceDashboardList);

  const doughnutChartOptions = {
    ...doughnutOptions,
    plugins: doughnutcommonPlugins,
  };
  const incidentBarOptions = {
    ...barOptions,
    scales: {
      x: {
        stacked: true,
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      y: {
        stacked: true,
        ticks: {
          beginAtZero: true,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
    },
    plugins: commonPlugins,
  };
  const tpvOptions = {
    ...barOptions,
    plugins: commonPlugins,
  };

  const pdfPageIds = [
    "#filterListAssetHealth",
    "#preventiveMaintenanceNIncidence",
    "#thirdPartyNWorkRequest",
  ];

  const { printDocument } = usePDFExport(
    [],
    pdfPageIds,
    "Maintenance Dashboard Report.pdf"
  );

  const goBack = () => {
    setRedirect(true);
  };
  const ndate = new Date().toJSON().slice(0, 10);
  const date =
    ndate.slice(8, 10) + "/" + ndate.slice(5, 7) + "/" + ndate.slice(0, 4);

  const incidentTotalCloseNcCount = incidentBarData.datasets[1].data.reduce(
    (acc, currentValue) => acc + currentValue,
    0
  );
  const inncidentTotalOpenNcCount = incidentBarData.datasets[0].data.reduce(
    (acc, currentValue) => acc + currentValue,
    0
  );
  const tpvTotalCloseNcCount = tpvData?.datasets[1].data.reduce(
    (acc, currentValue) => acc + currentValue,
    0
  );
  const { searchedItem } = location.state || {};

  const currentYear = searchedItem?.currentYear ?? new Date().getFullYear();
  const currentMonthNumber = searchedItem?.currentMonth;
  const currentMonth =
    currentMonthNumber !== undefined ? monthNames[currentMonthNumber - 1] : "";

  const quarterMonths = getQuarterMonths(startDate, endDate);
  const pmpYear = getQuarterRange(quarterMonths, startDate, endDate);

  const currentCity = searchedItem?.currentCity;
  const cityList = JSON.parse(localStorage.getItem("CitiesForStores"));
  const matchingCities = currentCity?.map((cityId) => {
    const matchingCity = cityList.cityInfos?.find(
      (city) => city?.cityId === cityId
    );
    return matchingCity ? matchingCity.cityName : null;
  });

  const selectedCityName =
    matchingCities?.filter((city) => city !== null).join(", ") ?? "";

  const currentStore = searchedItem?.storeId;

  const matchingStores = currentStore?.map((storeId) => {
    const matchingCity = storeList?.find((city) => city?.storeId === storeId);
    return matchingCity ? matchingCity.storeName : null;
  });

  const selectedStoreName =
    matchingStores?.filter((storeId) => storeId !== null).join(", ") ?? "";

  const totalHighCount =
    tpvData?.datasets[0].data[0] + tpvData?.datasets[1].data[0] ?? 0;
  const totalHighCloseCount = tpvData?.datasets[1].data[0] ?? 0;
  const pmpOpenCount = pmpChartData
    ?.filter((data) => data.pmpStatus !== "Completed")
    .reduce((acc, data) => acc + data.total, 0);
  const pmpCloseCount = pmpChartData?.find(
    (data) => data.pmpStatus === "Completed"
  ).total;
  const workRequestCloseData = WorkRequestChartData.find(
    (item) => item.alertType === "Close"
  )?.total;
  const workRequestOpenData = WorkRequestChartData.find(
    (item) => item.alertType === "Open"
  )?.total;
  const workRequestMonth = getMonthData(
    searchedItem?.currentYear ?? "",
    searchedItem?.currentMonth ?? ""
  );
  const preventiveTextCenter = doughnutChartCenterValue("Total PMP");
  const incidentTextCenter = doughnutChartCenterValue("Total incidents");
  const workRequestDataTextCenter = doughnutChartCenterValue("Realised");

  return (
    <div className="maintenance-report-page-main-div">
      {redirect && <Navigate to="/MaintenanceDashboard" />}
      <Header title="PDF Export" />
      <section>
        <div className="row maintenance-report-section-div">
          <div className="col-md-12 mt-60 alignrow">
            <button
              type="button"
              className="btn btn-secondary deca-btn-orange maintenance-report-goback-button"
              onClick={goBack}
            >
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
            <div>
              <button
                onClick={printDocument}
                className="deca-btn-yellow maintenance-export-to-pdf"
              >
                Export to PDF
              </button>
            </div>
          </div>
        </div>
        <div
          id="divToPrint"
          className="mt4 doughnut-chart-div maintenancediv-report-print"
        >
          <div id="filterListAssetHealth">
            <div className="row">
              <div className="col-md-2">
                <img
                  alt="decalogo"
                  src={require("./../PDFExport/logodecath.png")}
                  className="maintenance-report-logo"
                  width="150"
                  height="50"
                ></img>
              </div>
              <div className="col-md-10">
                <p className="maintenance-report-date">
                  {"Report Generated:" + " " + date}
                </p>
              </div>
            </div>

            <Divider className="maintenance-dashboard-report-divider" />
            <h3 className="report-page-heading">
              Maintenance Dashboard Report
            </h3>
            <div className="report-page-search-value-div">
              <div>
                <span>City: </span>
                {selectedCityName}
              </div>
              <div>
                <span>Store: </span>
                {selectedStoreName}
              </div>
              <div>
                <span>Month: </span>
                {currentMonth}
              </div>
              <div>
                <span>Year: </span>
                {currentYear}
              </div>
            </div>

            <h4 className="report-page-heading">Asset Health Alert Status</h4>
            <div className="asset-health-score-level-report">
              {renderStatusData(assetHealthStatusData)}
            </div>
            <div className="chart-report-details-div">
              <div className="gauge-component-class">
                <GaugeComponent
                  value={assetScore}
                  type="radial"
                  arc={assetHealthArc}
                  pointer={assetHealthPointer}
                  style={assetHealthStyle}
                />
              </div>
              <div className="report-meta-data-div">
                <div className="prevent-maintenance-showcard-child-div">
                  <span>Work Request Status: </span>
                  <span>Preventive Maintenance: </span>
                  <span>Third Party Audit: </span>
                </div>
                <div className="prevent-maintenance-showcard-child-div">
                  <span>High Priority Work Completion Status</span>
                  <span>Last Quarterly Realised</span>
                  <span>Sum of High and Medium Points</span>
                </div>
              </div>
            </div>

            <AssetHealthComponent
              assetScore={assetScore}
              preventiveMaintenanceScore={preventiveMaintenceScore}
              tpvScore={tpvScore}
              incidentScore={incidentScore}
              maintenanceWorkRequestScore={maintenanceWorkRequestScore}
              showcardClassName="report-meta-data-div"
              childClassName="prevent-maintenance-showcard-child-div"
            />
          </div>
          <div id="preventiveMaintenanceNIncidence">
            <div className="row">
              <div className="col-md-2">
                <img
                  alt="decalogo"
                  src={require("./../PDFExport/logodecath.png")}
                  className="maintenance-report-logo"
                  width="150"
                  height="50"
                ></img>
              </div>
              <div className="col-md-10">
                <p className="maintenance-report-date">
                  {"Report Generated:" + " " + date}
                </p>
              </div>
            </div>
            <Divider className="maintenance-dashboard-report-divider" />
            <h4 className="report-page-heading">Preventive Maintenance</h4>
            <div className="asset-health-score-level-report">
              {renderStatusData(preventiveMaintenanceDataStatusData)}
            </div>
            <div className="chart-report-details-div">
              <div className="doughnut-chart-div">
                <Doughnut
                  data={preventiveMaintenanceData}
                  options={doughnutChartOptions}
                  plugins={[preventiveTextCenter, ChartDataLabels]}
                />
              </div>
              <div className="report-meta-data-div">
                <PreventiveMaintenanceChildComponent
                  quarterMonths={quarterMonths}
                  pmpOpenCount={pmpOpenCount}
                  pmpCloseCount={pmpCloseCount}
                  pmpYear={pmpYear}
                  pmpYtdTotal={pmpYtdTotal}
                />
              </div>
            </div>
            <Divider className="maintenance-dashboard-report-divider" />
            <h4 className="report-page-heading">Maintenance Incidents</h4>
            <div className="asset-health-score-level-report">
              {renderStatusData(incidentBarStatusData)}
            </div>
            <div className="chart-report-details-div">
              <div className="doughnut-chart-div">
                <Bar
                  data={incidentBarData}
                  options={incidentBarOptions}
                  plugins={[ChartDataLabels]}
                />
              </div>
              <div className="report-meta-data-div">
                <IncidentChildComponent
                  currentYear={currentYear}
                  inncidentTotalOpenNcCount={inncidentTotalOpenNcCount}
                  incidentTotalCloseNcCount={incidentTotalCloseNcCount}
                  incidentTotalCount={incidentTotalCount}
                />
              </div>
            </div>
            <div className="asset-health-score-level-report">
              {renderStatusData(IncidentDoughnutStatusData)}
            </div>
            <div className="chart-report-details-div">
              <div className="doughnut-chart-div">
                <Doughnut
                  data={incidenDoughnutData}
                  options={doughnutChartOptions}
                  plugins={[incidentTextCenter, ChartDataLabels]}
                />
              </div>
              <div className="report-meta-data-div">
                <div className="prevent-maintenance-showcard-child-div">
                  {renderItemsWithLabelClass(
                    incidentMetaDataSecond,
                    "Total Incidents"
                  )}
                </div>
                <div className="prevent-maintenance-showcard-child-div">
                  <span className="quater-update-heading">
                    {incidentTotalCount}
                  </span>

                  {incidenDoughnutData?.datasets[0].data.map((data, index) => (
                    <span key={index}>{data}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div id="thirdPartyNWorkRequest">
            <div className="row">
              <div className="col-md-2">
                <img
                  alt="decalogo"
                  src={require("./../PDFExport/logodecath.png")}
                  className="maintenance-report-logo"
                  width="150"
                  height="50"
                ></img>
              </div>
              <div className="col-md-10">
                <p className="maintenance-report-date">
                  {"Report Generated:" + " " + date}
                </p>
              </div>
            </div>
            <Divider className="maintenance-dashboard-report-divider" />
            <h4 className="report-page-heading">Third Party Audit</h4>
            <div className="asset-health-score-level-report">
              {renderStatusData(tpvstatusData)}
            </div>
            <div className="chart-report-details-div">
              <div className="doughnut-chart-div">
                <Bar
                  data={tpvData}
                  options={tpvOptions}
                  plugins={[ChartDataLabels]}
                />
              </div>
              <div className="report-meta-data-div">
                <TpvChildComponent
                  currentYear={currentYear}
                  tpvTotalCount={tpvTotalCount}
                  totalHighCount={totalHighCount}
                  totalHighCloseCount={totalHighCloseCount}
                  tpvTotalCloseNcCount={tpvTotalCloseNcCount}
                />
              </div>
            </div>
            <Divider className="maintenance-dashboard-report-divider" />
            <h4 className="report-page-heading">Maintenance Work Request</h4>
            <div className="asset-health-score-level-report">
              {renderStatusData(workRequestStatusData)}
            </div>
            <div className="chart-report-details-div">
              <div className="doughnut-chart-div">
                <Doughnut
                  data={workRequestData}
                  options={doughnutChartOptions}
                  plugins={[workRequestDataTextCenter, ChartDataLabels]}
                />
              </div>
              <div className="report-meta-data-div">
                <WorkRequestChildComponent
                  workRequestMonth={workRequestMonth}
                  openData={workRequestOpenData}
                  closeData={workRequestCloseData}
                  currentYear={currentYear}
                  requestYdtTotal={requestYdtTotal}
                />
              </div>
            </div>
          </div>
        </div>

        {/* </div> */}
      </section>
    </div>
  );
}
